import axios from "axios";
import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import FadeIn from "react-fade-in/lib/FadeIn";
import LoadingData from "../../TESTPage/LoadingData";
import { FetchAxiosGet } from "../../../api/axios";
import { CheckBudgetYear } from "../../Function/CheckBudgetYear";
import {
  monthNames,
  leaveType,
  isInBudgetYear,
  isWeekend,
  isThaiHoliday,
  calHalfData,
} from "../../../helpers/leaveCard";

const API_URL = process.env.REACT_APP_API_CORS;

const ModalCardLeave = ({
  cardLeave,
  handleOpenCardLeave,
  searchReport,
  budGetYear,
  userID,
  userName = "",
  monthOn,
}) => {
  const numbers = Array.from({ length: 31 }, (_, index) => index + 1);
  const token = GetCookieToken("userToken");
  const userData = GetCookieData("userData");
  const currentBudgetYear = CheckBudgetYear();
  const [tableData, setTableData] = useState([]);
  const [tableHolidayData, setTableHolidayData] = useState([]);
  const [tableHolidayDataUnique, setTableHolidayDataUnique] = useState([]);
  const [budgetYear, setBudgetYear] = useState(null)
  const [leaveTypeHistory, setLeaveTypeHistory] = useState(null);
  const [leaveTypeHistoryLate, setLeaveTypeHistoryLate] = useState([]);  
  const [leaveTypeHistoryAttend, setLeaveTypeHistoryAttend] = useState([]);
  const [leaveTypeHistoryLost, setLeaveTypeHistoryLost] = useState([]);
  const [leaveTypeHistoryLateAllMonth, setLeaveTypeHistoryLateAllMonth] = useState([]);  
  const [leaveTypeHistoryLostAllMonth, setLeaveTypeHistoryLostAllMonth] = useState([]);
  const [dataCancelLeave, setDataCancelLeave] = useState([])
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [monthDataUniqueTime, setMonthDataUniqueTime] = useState([]);
  const [sumarymonthFirstHalf, setSumarymonthFirstHalf] = useState([]);
  const [sumarymonthLate, setSumarymonthLate] = useState([]);
  const [sumarymonthLost, setSumarymonthLost] = useState([]);
  const [sumarymonthSecondHalf, setSumarymonthSecondHalf] = useState([]);
  const [sumarymonthCountFirstHalf, setSumarymonthCountFirstHalf] = useState([]);
  const [sumarymonthCountSecondHalf, setSumarymonthCountSecondHalf] = useState([]);
  const [monthAll, setMonthAll] = useState([]);

  const handleFetchbyMonth = async (budYear, userID) => {//ข้อมูลเฉพาะใบลา key เป็นวันที่ที่มีการลา
    const url = `${API_URL}/api/report/leave/getLeaveCard`;
    try {
      const data = {
        user_id: userID === "" ? userData.user_id : Number(userID),
        budget_year: budYear,
        month_on: undefined,
      };

      const fetchCard = async (by) => {
        const res = await axios.post(
          url,
          { ...data, budget_year: by },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return res.data.data || {};
      };
      const safeFetch = (by) => fetchCard(by).catch(() => ({}));
      const [prevY, thisY, nextY] = await Promise.all([
        safeFetch(Number(budYear) - 1),
        safeFetch(Number(budYear)),
        safeFetch(Number(budYear) + 1),
      ]);
      const mergedData = { ...prevY, ...thisY, ...nextY };
      const urlCancel = `${API_URL}/api/leave/cancel/list/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 1000,
        "order[0]": "id_leave_date_list",
        "order[1]": "ASC",
        // "filter[id][0]": id,
      });
      const responseCancel = await axios.get(urlCancel, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },params
      });
      
      setDataCancelLeave(responseCancel.data.result)
      // console.log(response.data)
    const list = [];
      Object.keys(mergedData).forEach((element) => {
        const item = mergedData[element];
        const [yearPart, monthPart, dayPart] = element.split("-").map(Number);

        if (!isInBudgetYear(yearPart, monthPart, dayPart, budYear)) return;

        list.push({
          summaryDate: element,
          year: yearPart,
          month: monthPart,
          day: dayPart,
          leave_type_id: item.leave_type_id,
          leave_name: item.leave_name,
          leave_from_timetype: item.leave_from_timetype,
          leave_to_timetype: item.leave_to_timetype,
        });
      });
      setTableData((prev) => {
        const seen = new Set(list.map((x) => x.summaryDate));
        return [...list, ...prev.filter((x) => !seen.has(x.summaryDate))];
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (cardLeave === true) {
      if ( budGetYear !== null && budGetYear !== undefined && userID !== null && userID !== undefined ) {
          setLoading(true);
          setTableData([]);
          setMonthDataUniqueTime([]);
          setTableHolidayData([]);
          setLeaveTypeHistoryLate([]);
          setLeaveTypeHistoryLost([]);
          setLeaveTypeHistoryAttend([]);
          setLeaveTypeHistoryLateAllMonth([]);
          setLeaveTypeHistoryLostAllMonth([]);
          handleFetchbyMonth(budGetYear, userID);
          handleFetchHolidaybyBudgetYear(budGetYear);
          getLeaveDataTable(budGetYear, userID);
          leaveSummaryHistoryStatus(userID);  
          fetchBudgetYear();
        setTimeout(() => {
          setLoading(false);
        }, 1500);
      }
    }
  }, [budGetYear, userID, cardLeave]);

  useEffect(() => {
    if (cardLeave === true) {
      if (monthOn !== null && monthOn !== undefined && monthOn !== "") {
        const result = Array(monthNames.find((month) => month[1] === Number(monthOn)));
        setMonthAll(result);
      } else {
        setMonthAll(monthNames);
      }
    }
  }, [monthOn, cardLeave]);

  const handleFetchHolidaybyBudgetYear = async (budYear) => {
    const Christyear = budYear - 543;
    const url = `${API_URL}/api/masterdata/holiday/${Christyear - 1}`;
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      });

      response.data.result?.map((item) => {
        const formattedTime = new Date(item.date_start_holiday).toLocaleDateString("en-GB");
        const dayPart = formattedTime.split("/")[1];

        if (Number(dayPart) >= 10) {
          setTableHolidayData((prev) => [...prev, item]);

          const urlNext = `${API_URL}/api/masterdata/holiday/${Christyear}`;
          const responseBudgetYearNext = axios.get(urlNext, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          });
          responseBudgetYearNext.then((res) =>
            res.data.result.map((i) => {
              const formattedTime = new Date(
                i.date_start_holiday
              ).toLocaleDateString("en-GB");
              const dayPartNext = formattedTime.split("/")[1];
              if (Number(dayPartNext) <= 9) {
                setTableHolidayData((prev) => [...prev, i]);
              }
            })
          );
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getLeaveDataTable = async (budGetYear, userID) => {
    try {
      const url = API_URL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 400,
        "order[0]": "leave_data_id",
        "order[1]": "DESC",
        "filter[user_id][0]": userID,
        "filter[budget_year][0]": Number(budGetYear) - 1,
        "filter[budget_year][1]": Number(budGetYear),
        "filter[budget_year][2]": Number(budGetYear) + 1,
        "filter[leave_status][0]": 0,
        "filter[leave_status][1]": 5,
        "filter[leave_status][2]": "C",
      });
    
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        params,
      };
    
      const res = await axios.get(url, config);
    
      if (!Array.isArray(res.data.result)) {
        console.error("❌ API result is not array:", res.data.result);
        return;
      }
    
      const rawLeave = res.data.result;
    
      const explodeLeaveDays = (item) => {
        const from = new Date(item.leave_from_date_dmy);
        const to = new Date(item.leave_to_date_dmy);
      
        const days = [];
      
         for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
          const y = d.getFullYear();
          const m = d.getMonth() + 1;
          const day = d.getDate();
          if (!isInBudgetYear(y, m, day, budGetYear)) continue;
          days.push({
            year: y,
            month: m,
            day: day,
            leave_type_id: item.leave_type_id,
            leave_data_id: item.leave_data_id,
            leave_days: item.leave_days,
            leave_name: item.leave_name,
            leave_from_timetype: item.leave_from_timetype,
            leave_to_timetype: item.leave_to_timetype,
            budget_year: item.budget_year,
          });
        }
      
        return days;
      };
    
      let allDays = [];
      rawLeave.forEach((item) => {
        allDays.push(...explodeLeaveDays(item));
      });
      
      const fromDatatable = allDays
        .filter((d) => Number(d.budget_year) !== Number(budGetYear))
        .map((d) => ({
          summaryDate: `${d.year}-${String(d.month).padStart(2, "0")}-${String(d.day).padStart(2, "0")}`,
          year: d.year,
          month: d.month,
          day: d.day,
          leave_type_id: d.leave_type_id,
          leave_name: d.leave_name,
          leave_from_timetype: d.leave_from_timetype,
          leave_to_timetype: d.leave_to_timetype,
        }));

      setTableData((prev) => {
        const seen = new Set(prev.map((x) => x.summaryDate));
        return [...prev, ...fromDatatable.filter((x) => !seen.has(x.summaryDate))];
      });
    
      const summaryByMonth = {};
      const usedLeaveData = {}; // เก็บ leave_data_id ที่เคยบวกแล้ว

      allDays.forEach((d) => {
        const key = `${d.year}-${d.month}-${d.leave_type_id}-${d.leave_data_id}`;
      
        if (!summaryByMonth[key]) {
          summaryByMonth[key] = {
            year: d.year,
            month: d.month,
            leave_type_id: d.leave_type_id,
            leave_data_id: d.leave_data_id,
            leave_days: 0,
          };
          usedLeaveData[key] = new Set();
        }
      
        //  กันไม่ให้ leave_data_id ซ้ำ
        if (!usedLeaveData[key].has(d.leave_data_id)) {
          summaryByMonth[key].leave_days += d.leave_days;
          usedLeaveData[key].add(d.leave_data_id);
        }
      });
    
      const finalMonthSummary = Object.values(summaryByMonth);
    
      setMonthDataUniqueTime(finalMonthSummary);
    } catch (err) {
      console.error("❌ Error in getLeaveDataTable:", err);
    }
  };

  useEffect(() => {
    if (dataCancelLeave.length > 0) {
      const halfRound = monthNames.length / 2 
      
      const firstHalfData = monthDataUniqueTime.filter(item => {
          const monthIndex = monthNames.findIndex(month => month[1] === item.month);
          return monthIndex !== -1 && monthIndex < halfRound;
      });
      const resultfirstHalfData = leaveType.map(typeId => {
          const totalDays = firstHalfData
              .filter(item => item.leave_type_id === typeId)
              .reduce((total, item) => total + item.leave_days, 0);
          return { leave_type_id: typeId, leave_days: totalDays };
      });
      setSumarymonthFirstHalf(resultfirstHalfData)
      const leaveFirstHalfDataCount = {};
      firstHalfData.forEach(item => {
          if (!leaveFirstHalfDataCount[item.leave_type_id]) {
              leaveFirstHalfDataCount[item.leave_type_id] = {};
              leaveFirstHalfDataCount[item.leave_type_id][item.leave_data_id] = 1;
          } else {
              if (!leaveFirstHalfDataCount[item.leave_type_id][item.leave_data_id]) {
                  leaveFirstHalfDataCount[item.leave_type_id][item.leave_data_id] = 1;
              }
          }
      });
      const resultCountFirstHalfData = [];
      for (const leaveTypeId in leaveFirstHalfDataCount) {
          const count = Object.keys(leaveFirstHalfDataCount[leaveTypeId]).length;
          resultCountFirstHalfData.push({ leave_type_id: leaveTypeId, leave_data_id_count: count });
      }
      setSumarymonthCountFirstHalf(resultCountFirstHalfData)

      const secondHalfData = monthDataUniqueTime.filter(item => {
          const monthIndex = monthNames.findIndex(month => month[1] === item.month);
          return monthIndex !== -1 && monthIndex >= halfRound;
      }); 
      const resultsecondHalfData = leaveType.map(typeId => {
          const totalDays = secondHalfData
              .filter(item => item.leave_type_id === typeId)
              .reduce((total, item) => total + item.leave_days, 0);
          return { leave_type_id: typeId, leave_days: totalDays };
      });
      setSumarymonthSecondHalf(resultsecondHalfData)
      const leaveSecondHalfDataCount = {};
      secondHalfData.forEach(item => {
          if (!leaveSecondHalfDataCount[item.leave_type_id]) {
              leaveSecondHalfDataCount[item.leave_type_id] = {};
              leaveSecondHalfDataCount[item.leave_type_id][item.leave_data_id] = 1;
          } else {
              if (!leaveSecondHalfDataCount[item.leave_type_id][item.leave_data_id]) {
                  leaveSecondHalfDataCount[item.leave_type_id][item.leave_data_id] = 1;
              }
          }
      });
      const resultCountSecondHalfData = [];
      for (const leaveTypeId in leaveSecondHalfDataCount) {
          const count = Object.keys(leaveSecondHalfDataCount[leaveTypeId]).length;
          resultCountSecondHalfData.push({ leave_type_id: leaveTypeId, leave_data_id_count: count });
      }
      setSumarymonthCountSecondHalf(resultCountSecondHalfData)
    }
  }, [monthDataUniqueTime,dataCancelLeave])

  
  useEffect(() => {
    if (leaveTypeHistoryLateAllMonth.length > 0 || leaveTypeHistoryLostAllMonth.length > 0) {
        let newObjectLate = calHalfData(leaveTypeHistoryLateAllMonth)
        setSumarymonthLate(newObjectLate)
        let newObjectLost = calHalfData(leaveTypeHistoryLostAllMonth)
        setSumarymonthLost(newObjectLost)
    }
  }, [leaveTypeHistoryLateAllMonth,leaveTypeHistoryLostAllMonth])

  useEffect(() => {
    if (cardLeave === true) {
      if (tableHolidayData) {
        const uniqueData = Array.from(
          new Set(tableHolidayData.map(JSON.stringify))
        ).map(JSON.parse);
        setTableHolidayDataUnique(uniqueData);
      }
    }
  }, [tableHolidayData, cardLeave]);

  const leaveSummaryHistoryStatus = async (userIDs) => {
    const url = API_URL + "/api/time/history";
    const params = new URLSearchParams({
      page: 1,
      size: 100000,
      "order[0]": "scan_date",
      "order[1]": "ASC",
      "filter[user_id][0]": userIDs,
      "filter[budget_year][0]": Number(budGetYear) - 1,
      "filter[budget_year][1]": Number(budGetYear),
      "filter[budget_year][2]": Number(budGetYear) + 1,
      // "filter[entry_exit_status][0]": "0",
      // "filter[entry_exit_status][1]": "1",
      // "filter[entry_exit_status][2]": "2",
      // "filter[entry_exit_status][3]": "4",
      // "filter[entry_exit_status][4]": "5",
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    try {
      const res = await axios.get(url, config);
      let result = res?.data?.result

      let absentCount = 0;
      let lateCount = 0;
      let prevIndex = -1;
      let prevIndexLate = -1;

      const leaveConfig = await FetchAxiosGet("/api/leave/config/all",token)
      const Christyear = budGetYear - 543;
      const holiday = await FetchAxiosGet(`/api/masterdata/holiday/${Christyear}`,token)

      result.map((element, index, array) => {
        
        const formattedTimeFrom = new Date(element.date).toLocaleDateString("en-GB");
        const dayFrom = formattedTimeFrom.split("/")[0];
        const monthFrom = formattedTimeFrom.split("/")[1];
        const yearFrom = formattedTimeFrom.split("/")[2];

        if (!isInBudgetYear(Number(yearFrom), Number(monthFrom), Number(dayFrom), budGetYear)) return null;

        const resHoliday = isWeekend(`${yearFrom}-${monthFrom}-${dayFrom}`);

        const resWeekHoliday = isThaiHoliday(`${yearFrom}-${monthFrom}-${dayFrom}`, holiday.result)

        if (element.late == null && element.entry_exit_status == 0) {
          const migrateDate = new Date (leaveConfig.migrate.date)
          const currentDate = new Date (element.scan_date)
          const forenoonLateDate = new Date (currentDate)
          forenoonLateDate.setUTCHours(9, 30, 0, 0);
          const afternoonLateDate = new Date (currentDate)
          afternoonLateDate.setUTCHours(10, 0, 0, 0);
          const hightNoonLateDate = new Date (currentDate)
          hightNoonLateDate.setUTCHours(14, 1, 0, 0);
          const LateDate = new Date (currentDate)
          LateDate.setUTCHours(14, 30, 0, 0);
          if (currentDate >= migrateDate) {
            if (currentDate > forenoonLateDate && currentDate < afternoonLateDate ) {
              element.late = 2
            } else if (currentDate > hightNoonLateDate && currentDate < LateDate ){
              element.late = 3
            }
            // ถ้าจะเพิ่มเงื่อนไขของการสายครึ่งบ่ายให้มาเพิ่มตรงนี้ ในกรณีสำหรับดึงข้อมูลเก่ามา
          } else {
            if (currentDate > forenoonLateDate && currentDate < afternoonLateDate ) {
              element.late = 1
            }
          }
          
        }
        
        if (element.entry_exit_status === 4 || (element.entry_exit_status === 0 && element.note.trim() === "ไม่ลงเวลาออกงาน")) {
          if (!resHoliday && !resWeekHoliday) {
            monthNames.map((month, monthIdx) => {
                let newObject = {
                  monthIdx: index,
                  dataObject: element,
                  data: `${yearFrom}-${monthFrom}-${dayFrom}`,
                  day: Number(dayFrom),
                  month: Number(monthFrom),
                  year: Number(yearFrom),
                };
                setLeaveTypeHistoryLost((prev) => [...prev.filter(x => x.monthIdx !== index), newObject]);
                if (Number(monthFrom) === month[1]) {
                  absentCount++
                  if (prevIndex !== monthIdx) {
                    absentCount = 1
                  }
                  prevIndex = monthIdx;
                  let newObject = {
                    monthIdx: index,
                    count: absentCount,
                    month: Number(monthFrom),
                  };
                  setLeaveTypeHistoryLostAllMonth((prev) => [...prev.filter(x => x.monthIdx !== index), newObject,]);
                  
                }
            })
          }
        } else if (element.late === 1 || element.late === 2 || element.late === 3 ) {

          if (!resHoliday && !resWeekHoliday) {
            if (element.late === 2 || element.late === 3) {
              lateCount = lateCount - 0.5
            }
            monthNames.map((month, monthIdx) => {
              let newObject = {
                monthIdx: index,
                dataObject: element,
                data: `${yearFrom}-${monthFrom}-${dayFrom}`,
                day: Number(dayFrom),
                month: Number(monthFrom),
                year: Number(yearFrom),
              };
              
              setLeaveTypeHistoryLate((prev) => [...prev.filter(x => x.monthIdx !== index), newObject]);
              if (Number(monthFrom) === month[1]) {
                lateCount++
                if (prevIndexLate !== monthIdx) {
                  lateCount = 1
                }
                prevIndexLate = monthIdx;
                let newObject = {
                  monthIdx: index,
                  count: lateCount,
                  month: Number(monthFrom),
                };
                setLeaveTypeHistoryLateAllMonth((prev) => [...prev.filter(x => x.monthIdx !== index), newObject]);
              }
            });
          }
        } else if (element.entry_exit_status === 0 && element.note.trim() !== "ไม่ลงเวลาออกงาน") {
          monthNames.map((month, monthIdx) => {
            let newObject = {
              dataObject: element,
              data: `${yearFrom}-${monthFrom}-${dayFrom}`,
              day: Number(dayFrom),
              month: Number(monthFrom),
              year: Number(yearFrom),
            };
            setLeaveTypeHistoryAttend((prev) => [...prev, newObject]);
          });
        }
        return null;
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleExitCardLeave = () => {
    setSumarymonthCountSecondHalf([]);
    setSumarymonthCountFirstHalf([]);
    setSumarymonthLate([]);
    setSumarymonthLost([]);
    setMonthDataUniqueTime([]);
    setTableData([]);
    setDataCancelLeave([]);
    setTableHolidayData([]);
    setTableHolidayDataUnique([]);
    setLeaveTypeHistory([]);
    setLeaveTypeHistoryLate([]);
    setLeaveTypeHistoryLost([]);
    setLeaveTypeHistoryAttend([]);
    setLeaveTypeHistoryLateAllMonth([]);
    setLeaveTypeHistoryLostAllMonth([]);
    setMonthAll([]);
    handleOpenCardLeave();
  };

  const pdfRef = useRef();

  const downloadPDF = async () => {
    setButtonLoading(true);
    const input = pdfRef.current;
    await html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("l", "mm", "a4", true); //แนวนอน
      // const pdf = new jsPDF("", "mm", "a4", true);   //แนวตั้ง
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;

      const imgY = 5;
      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save("บัตรวันลา ของข้าราชการและลูกจ้าง.pdf");
    });
    setButtonLoading(false);
  };
  
  let idRefferrent = []

  const fetchBudgetYear = async () => {
    const urlCheckRound = `${API_URL}/api/evaluateSalary/checkRound`;
    const config = {headers: {Authorization: `Bearer ${token}`}};
    await axios.get(urlCheckRound, config).then(response => {
      setBudgetYear(response.data.result.this_budget_year)
    });
  };

  const isThaiPublic = (date) => {
    const localDate = new Date(date);
    localDate.setHours(0, 0, 0, 0);

    return tableHolidayDataUnique.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(0, 0, 0, 0);
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return (localDate >= startDate && localDate <= endDate);
      }
    );
  };
  
  return (
    <Modal centered size="xl" style={{minWidth:"1300px"}} isOpen={cardLeave} toggle={handleExitCardLeave}>
      <ModalHeader toggle={handleExitCardLeave}>
        <h4>บัตรวันลา</h4> 
      </ModalHeader>

      <ModalBody style={{ overflowX: "scroll"}}>
        {loading ? (
          <LoadingData />
        ) : (
          <FadeIn>
            <div ref={pdfRef} style={{fontFamily: "Sarabun,serif", minWidth:"1200px"}}>
              <Row className="mx-1">
                <Col xxl={12} className="mb-2">
                  <h4 className="mb-0">บัตรวันลาของ <span className="text-success">{userName}</span> ปีงบประมาณ พ.ศ. {searchReport?.budget_year}</h4>
                </Col>
                <Col xxl={12}>
                  <Table bordered responsive>
                    <thead className="table-light text-center" style={{ verticalAlign: "middle" }}>
                      <tr>
                        <th rowSpan={2} className="p-1">เดือน/วันที่</th>
                        {numbers.map((number, idx) => {return <th rowSpan={2} key={number} style={{ width: "20px", padding: "0.1rem" }}>{number}</th>})}
                        <th className="p-1" style={{ width: "58px", background: "#6699AA" }} colSpan={2}> ป </th>
                        <th className="p-1" style={{ width: "58px", background: "#FFFF88" }} colSpan={2}> ก </th>
                        <th className="p-1" style={{ width: "29px", background: "#FF9797" }} colSpan={1}> ส </th>
                        <th className="p-1" style={{ width: "29px", background: "#88BBDD" }} colSpan={1}> ข </th>
                        <th className="p-1" style={{ width: "29px", background: "#7776B3" }} colSpan={2}> ล </th>
                        <th className="p-1" style={{ width: "58px", background: "#000000", color: "white" }} colSpan={2}> พ </th>
                        <th className="p-1" style={{ width: "29px", background: "#CBAB8D" }} colSpan={1}> บ </th>
                        <th className="p-1" style={{ width: "29px", background: "#88BBAA" }} colSpan={1}> ค </th>
                        <th className="p-1" style={{ width: "58px", background: "#B9E3AE" }} colSpan={2}> ศ </th>
                        <th className="p-1" style={{ width: "29px", background: "#BACAB3" }} colSpan={1}> ม </th>
                        <th className="p-1" style={{ width: "29px", background: "#FFBE7D" }} colSpan={1}> ฮ </th>
                        <th className="p-1" style={{ width: "58px", background: "#C96868" }} colSpan={2}> น </th>
                      </tr>
                      <tr>
                        <th className="p-1">ครั้ง</th>
                        <th className="p-1">วัน</th>
                        <th className="p-1">ครั้ง</th>
                        <th className="p-1">วัน</th>
                        <th className="p-1">ครั้ง</th>
                        <th className="p-1">ครั้ง</th>
                        <th className="p-1">ครั้ง</th>
                        <th className="p-1">วัน</th>
                        <th className="p-1">ครั้ง</th>
                        <th className="p-1">วัน</th>
                        <th className="p-1">วัน</th>
                        <th className="p-1">วัน</th>
                        <th className="p-1">ครั้ง</th>
                        <th className="p-1">วัน</th>
                        <th className="p-1">ครั้ง</th>
                        <th className="p-1">วัน</th>
                        <th className="p-1">ครั้ง</th>
                        <th className="p-1">วัน</th>
                      </tr>
                    </thead>
                    <tbody>
                      {monthAll?.map((month, monthIndex) => {
                        let totalcount = 0
                        return (
                          <tr className="text-center" key={monthIndex}>
                            <td className="p-0" style={{ verticalAlign: "middle", whiteSpace: "nowrap" }}>{month[0]}</td>
                            {numbers.map((number, idx) =>
                                 (() => {
                                    let ChristBudgetYear = null;
                                    const elementMonth = tableData.map((i) => i.month);
                                    const elementLate = leaveTypeHistoryLate.map((i) => i.month);
                                    const elementLost = leaveTypeHistoryLost.map((i) => i.month);
                                    const elementAttend = leaveTypeHistoryAttend.map((i) => i.month);
                                    const elementYear = tableData.map((i) => i.year);

                                    let res = null;
                                    let res2 = null;
                                    const uniqueDataSet = [ ...new Set(elementMonth) ];
                                    const uniqueDataLateSet = [ ...new Set(elementLate) ];
                                    const uniqueDataLostSet = [ ...new Set(elementLost) ];
                                    const uniqueDataAttendSet = [ ...new Set(elementAttend) ];
                                    if(budGetYear){
                                      let Christyear = Number(budGetYear) - 543
                                      if ( month[1] === 10 || month[1] === 11 || month[1] === 12 ) {
                                        ChristBudgetYear = `${Christyear - 1}-${month[1]}-${number}`;
                                      } else {
                                        //เช็คเดือนกุมภาว่าปีนั้นๆมีกี่วัน 28 หรือ 29
                                        if (month[1] === 2) {
                                          if ((Christyear % 4 === 0 && Christyear % 100 !== 0) || Christyear % 400 === 0) {
                                            if (number <= 29) {
                                              ChristBudgetYear = `${Christyear}-${month[1]}-${number}`;
                                            }
                                          } else {
                                            if (number <= 28) {
                                              ChristBudgetYear = `${Christyear}-${month[1]}-${number}`;
                                            }
                                          }
                                        } else {
                                          ChristBudgetYear = `${Christyear}-${month[1]}-${number}`;
                                        }
                                      }
                                    }
                                    res = isWeekend(ChristBudgetYear);
                                    res2 = isThaiPublic(ChristBudgetYear);

                                    let boolCheckLate = uniqueDataLateSet?.find((i) => i === month[1]);
                                    let boolCheckLost = uniqueDataLostSet?.find((i) => i === month[1]);
                                    let boolCheckAttend = uniqueDataAttendSet?.find((i) => i === month[1]);
                                    let boolCheck = uniqueDataSet?.find((i) => i === month[1]);

                                    const filteredDataLate = leaveTypeHistoryLate.filter((item) => item.month === boolCheckLate );
                                    const filteredDataLost =leaveTypeHistoryLost.filter((item) => item.month === boolCheckLost);
                                    const filteredDataAttend =leaveTypeHistoryAttend.filter((item) => item.month === boolCheckAttend);
                                    const filteredData = tableData.filter((item) => item.month === boolCheck);

                                    const uniqueDataLateArray = filteredDataLate.filter((item, index, self) => {return (index === self.findIndex((t) => t.data === item.data))});
                                    const uniqueDataAttendArray = filteredDataAttend.filter((item, index, self) => {return (index === self.findIndex((t) => t.data === item.data))});
                                    const uniqueDataLostArray = filteredDataLost.filter((item, index, self) => {return (index === self.findIndex((t) => t.data === item.data))});
                                    const uniqueDataArray = filteredData.filter((item, index, self) => {return (index === self.findIndex((t) => t.summaryDate === item.summaryDate))});
                                    
                                    let count = null;
                                    if (boolCheck) {
                                      if ( uniqueDataArray !== null && uniqueDataArray !== undefined) {
                                        if (uniqueDataArray.find((i) => i.day === number)) {
                                          count = uniqueDataArray.find((i) => i.day === number);
                                        }
                                      }
                                    }
                                    let countLate = null;
                                    if (boolCheckLate) {
                                      if ( uniqueDataLateArray !== null && uniqueDataLateArray !== undefined) {
                                        if (uniqueDataLateArray.find((i) => i.day === number)) {
                                            countLate = uniqueDataLateArray.find((i) => i.day === number);
                                        }
                                      }
                                    }
                                    let countLost = null;
                                    if (boolCheckLost) {
                                      if ( uniqueDataLostArray !== null && uniqueDataLostArray !== undefined) {
                                        if (uniqueDataLostArray.find((i) => i.day === number)) {
                                            countLost = uniqueDataLostArray.find((i) => i.day === number);
                                        }
                                      }
                                    }
                                    let countAttend = null;
                                    if (boolCheckAttend) {
                                      if ( uniqueDataAttendArray !== null && uniqueDataAttendArray !== undefined) {
                                        if (uniqueDataAttendArray.find((i) => i.day === number)) {
                                            countAttend = uniqueDataAttendArray.find((i) => i.day === number);
                                        }
                                      }
                                    }

                                    return (
                                    uniqueDataSet.includes(month[1]) ? (
                                      res || res2 ? (
                                        <td className="p-0" key={number} style={{ height: "30px" }}>
                                          <div style={{background:"rgba(255,151,151,0.5)",height: "30px", }}></div>
                                        </td>
                                      ) : 
                                          boolCheck ? (count || countLate || countLost ? 
                                          <td 
                                            className="p-0" 
                                            key={number} 
                                            style={
                                              { height: "30px",
                                                verticalAlign:  count?.leave_from_timetype != count?.leave_to_timetype ? "middle" 
                                                                : count?.leave_from_timetype == 1 && count?.leave_to_timetype == 1 ? "top" 
                                                                : count?.leave_from_timetype == 2 && count?.leave_to_timetype == 2 ? "bottom" 
                                                                : countLate?.dataObject?.late == 2 ? "top" 
                                                                : countLate?.dataObject?.late == 3 ? "bottom" 
                                                                : "" ,
                                              }
                                            }
                                          >
                                            {count?.leave_type_id === 1 ? (
                                              <div style={{ background: "#6699AA",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle", color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "ป"}
                                              </div>
                                            ) : count?.leave_type_id === 2 ? (
                                              <div style={{background: "#FFFF88",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "black"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "ก"}
                                              </div>
                                            ) : count?.leave_type_id === 4 ? (
                                              <div style={{background: "#000",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "พ"}
                                              </div>
                                            ) : count?.leave_type_id === 13 ? (
                                              <div style={{background: "#CBAB8D",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "บ"}
                                              </div>
                                            ) : count?.leave_type_id === 3 ? (
                                              <div style={{background: "#88BBAA",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "ค"}
                                              </div>
                                            ) : count?.leave_type_id === 9 ? (
                                              <div style={{background: "#B9E3AE",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "ศ"}
                                              </div>
                                            ) : count?.leave_type_id === 10 ? (
                                              <div style={{background: "#BACAB3",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "ม"}
                                              </div>
                                            ) : count?.leave_type_id === 8 ? (
                                              <div style={{background: "#FFBE7D",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "ฮ"}
                                              </div>
                                            ) : count?.leave_type_id === 7 ? (
                                              <div style={{background: "#FFBE7D",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "ฮ"}
                                              </div>
                                            ) : count?.leave_type_id === 6 ? (
                                              <div style={{background: "#FFBE7D",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "ฮ"}
                                              </div>
                                            ) : count?.leave_type_id === 12 ? (
                                              <div style={{background: "#7776B3",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "ล"}
                                              </div>
                                            ) : count?.leave_type_id === 11 ? (
                                              <div style={{background: "#C96868",height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",verticalAlign: "middle",color: "white"}}>
                                                {count?.leave_from_timetype != count?.leave_to_timetype && "น"}
                                              </div>
                                            ) : countLate ? (
                                              // สายครึ่งเช้าครึ่งบ่ายค่อยทำ
                                              <div 
                                                style={
                                                  { background: "#FF9797",
                                                    height: countLate?.dataObject?.late == 1 ? "30px" : countLate?.dataObject?.late == 2 ? "15px" : countLate?.dataObject?.late == 3 ? "15px" : "",
                                                    verticalAlign: "middle",color: "white"
                                                  }
                                                }
                                              >
                                                {countLate?.dataObject?.late == 1 && "ส"}
                                                {/* ส */}
                                              </div>
                                            ) : countLost ? (
                                              <div 
                                                style={
                                                  { background: "#88BBDD",
                                                    // height: count?.leave_from_timetype != count?.leave_to_timetype ? "30px" : "15px",
                                                    height: "30px",
                                                    verticalAlign: "middle",color: "white"
                                                  }
                                                }
                                              >
                                                {/* {count?.leave_from_timetype != count?.leave_to_timetype && "ข"} */}
                                                ข
                                              </div>
                                            ) : ""
                                            }
                                          </td>
                                          : countAttend ? <td className="p-0" key={number} style={{height: "30px", verticalAlign: "middle", }}> / </td> : <td className="p-0"></td>
                                        
                                      ) : countAttend && <td className="p-0" key={number} style={{height: "30px",verticalAlign: "middle", }}>/</td>
                                      
                                    ) : res || res2 ? 
                                      <td className="p-0" key={number} style={{ height: "30px" }}>
                                        <div style={{background: "rgba(255,151,151,0.5)",height: "30px", }}></div>
                                      </td>
                                      : countLate ?  
                                      <td className="p-0" key={number} style={{height: "30px",verticalAlign: "middle", }}>
                                        <div style={{background: "#FF9797",height: "30px",verticalAlign: "middle",color: "white"}}>
                                          ส
                                        </div>
                                      </td>
                                      : countLost ? 
                                        <td className="p-0" key={number} style={{height: "30px",verticalAlign: "middle", }}>
                                          <div style={{background: "#88BBDD",height: "30px",verticalAlign: "middle",color: "white"}}>
                                            ข
                                          </div>
                                        </td>
                                        // new Date().getMonth() + 1 เพราะ new Date().getMonth() เก็บเป็น Array โดยเดือนแรกจะเริ่มต้นที่ 0 
                                      // : countAttend ? <td className="p-0" key={number} style={{height: "30px",verticalAlign: "middle", }}>/</td> 
                                      : monthAll.findIndex(month => month[1] === new Date().getMonth() + 1) >= monthIndex || monthAll.length === 1 ?
                                          // ใช้ countAttend ในการเช็คการเข้างาน
                                          countAttend ? 
                                            <td className="p-0" key={number} style={{height: "30px",verticalAlign: "middle", }}>/</td>
                                          : <td className="p-0"></td>
                                          // <td className="p-0" key={number} style={{height: "30px",verticalAlign: "middle"}}>/</td>
                                      : <td className="p-0" key={number} style={{height: "30px",verticalAlign: "middle"}}>{currentBudgetYear == budGetYear ? "" : "/"}</td>
                                  )})()
                            )}
                            {/* {console.log(monthDataUniqueTime)
                            } */}
                            {leaveType.map((i,idx)=>{
                              let result = 0;
                                return(
                                i !== 7 && i !== 6 && 
                                  (<Fragment key={idx}>
                                    {i === 1 &&
                                      <Fragment>
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              { monthDataUniqueTime.map((item,itemIdx)=>{
                                                totalcount = 0
                                                if (Number(item.month) === month[1] && item.leave_type_id === i ) {
                                                  if(idRefferrent.some((a) => a === item?.leave_data_id)){
                                                    totalcount = totalcount + 0
                                                    idRefferrent.filter((a) => a !== item?.leave_data_id)
                                                    return totalcount
                                                  }else{
                                                    totalcount = totalcount + 1
                                                    idRefferrent.push(item.leave_data_id)
                                                    return totalcount
                                                  }
                                                } return 0 }).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                              }
                                              
                                          </td>
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              { monthDataUniqueTime.map((item,itemIdx)=>{
                                                return( Number(item.month) === month[1] 
                                                    && item.leave_type_id === i 
                                                      ? Number(item.leave_days) + result : result + result )})
                                                      .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                              }
                                          </td>  
                                      </Fragment>
                                    }
                                    {i === 2 &&
                                      <Fragment>
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              { monthDataUniqueTime.map((item,itemIdx)=>{
                                                  totalcount = 0
                                                  if (Number(item.month) === month[1] && item.leave_type_id === i ) {
                                                    if(idRefferrent.some((a) => a === item?.leave_data_id)){
                                                      totalcount = totalcount + 0
                                                      idRefferrent.filter((a) => a !== item?.leave_data_id)
                                                      return totalcount
                                                    }else{
                                                      totalcount = totalcount + 1
                                                      idRefferrent.push(item.leave_data_id)
                                                      return totalcount
                                                    }
                                                  } return 0 }).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                              }
                                        </td>
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                            { monthDataUniqueTime.map((item,itemIdx)=>{
                                              return( Number(item.month) === month[1] 
                                                  && item.leave_type_id === i 
                                                    ? Number(item.leave_days) + result : result + result )})
                                                    .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                            }
                                        </td>  
                                    </Fragment>
                                    }
                                    {i === 66 &&
                                      <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                        {leaveTypeHistoryLateAllMonth.find((item) => item.month === month[1]) ? 
                                          leaveTypeHistoryLateAllMonth.filter((item) => item.month === month[1])
                                            ?.reduce((max, obj) => obj.count > max.count ? obj : max, leaveTypeHistoryLateAllMonth.filter((item) => item.month === month[1])[0])?.count : "0" }
                                      </td>
                                    }
                                    {i === 77 &&
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {leaveTypeHistoryLostAllMonth.find((item) => item.month === month[1]) ? 
                                          leaveTypeHistoryLostAllMonth.filter((item) => item.month === month[1])
                                            ?.reduce((max, obj) => obj.count > max.count ? obj : max, leaveTypeHistoryLostAllMonth.filter((item) => item.month === month[1])[0])?.count : "0" }
                                    </td>
                                    }
                                    {i === 12 &&
                                      <Fragment>
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          { monthDataUniqueTime.map((item,itemIdx)=>{
                                                    totalcount = 0
                                                    if (Number(item.month) === month[1] && item.leave_type_id === i ) {
                                                      if(idRefferrent.some((a) => a === item?.leave_data_id)){
                                                        totalcount = totalcount + 0
                                                        idRefferrent.filter((a) => a !== item?.leave_data_id)
                                                        return totalcount
                                                      }else{
                                                        totalcount = totalcount + 1
                                                        idRefferrent.push(item.leave_data_id)
                                                        return totalcount
                                                      }
                                                    } 
                                                    return 0 }).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                                }
                                          </td>
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              { monthDataUniqueTime.map((item,itemIdx)=>{
                                                return( Number(item.month) === month[1] 
                                                    && item.leave_type_id === i 
                                                      ? Number(item.leave_days) + result : result + result )})
                                                      .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                              }
                                          </td>
                                      </Fragment>
                                    }
                                    {i === 4 &&
                                      <Fragment>
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                        { monthDataUniqueTime.map((item,itemIdx)=>{
                                                  totalcount = 0
                                                  if (Number(item.month) === month[1] && item.leave_type_id === i ) {
                                                    if(idRefferrent.some((a) => a === item?.leave_data_id)){
                                                      totalcount = totalcount + 0
                                                      idRefferrent.filter((a) => a !== item?.leave_data_id)
                                                      return totalcount
                                                    }else{
                                                      totalcount = totalcount + 1
                                                      idRefferrent.push(item.leave_data_id)
                                                      return totalcount
                                                    }
                                                  } 
                                                  return 0 }).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                              }
                                        </td>
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                            { monthDataUniqueTime.map((item,itemIdx)=>{
                                              return( Number(item.month) === month[1] 
                                                  && item.leave_type_id === i 
                                                    ? Number(item.leave_days) + result : result + result )})
                                                    .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                            }
                                        </td>  
                                    </Fragment>
                                    }
                                    {i === 13 &&
                                      <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          { monthDataUniqueTime.map((item,itemIdx)=>{
                                            return( Number(item.month) === month[1] 
                                                && item.leave_type_id === i 
                                                  ? Number(item.leave_days) + result : result + result )})
                                                  .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                          }
                                      </td> 
                                    }
                                    {i === 3 &&
                                      <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          { monthDataUniqueTime.map((item,itemIdx)=>{
                                            return( Number(item.month) === month[1] 
                                                && item.leave_type_id === i ? Number(item.leave_days) + result : result + result )}).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                          }
                                      </td> 
                                    }
                                    {i === 9 &&
                                      <Fragment>
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          { monthDataUniqueTime.map((item,itemIdx)=>{
                                                  totalcount = 0
                                                  if (Number(item.month) === month[1] && item.leave_type_id === i ) {
                                                    if(idRefferrent.some((a) => a === item?.leave_data_id)){
                                                      totalcount = totalcount + 0
                                                      idRefferrent.filter((a) => a !== item?.leave_data_id)
                                                      return totalcount
                                                    }else{
                                                      totalcount = totalcount + 1
                                                      idRefferrent.push(item.leave_data_id)
                                                      return totalcount
                                                    }
                                                  } return 0 }).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                              }
                                          </td>
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              { monthDataUniqueTime.map((item,itemIdx)=>{
                                                return( Number(item.month) === month[1] 
                                                    && item.leave_type_id === i 
                                                      ? Number(item.leave_days) + result : result + result )})
                                                      .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                              }
                                          </td>  
                                      </Fragment>
                                    }
                                    {i === 10 &&
                                      <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              { monthDataUniqueTime.map((item,itemIdx)=>{
                                                  totalcount = 0
                                                  if (Number(item.month) === month[1] && item.leave_type_id === i ) {
                                                    if(idRefferrent.some((a) => a === item?.leave_data_id)){
                                                      totalcount = totalcount + 0
                                                      idRefferrent.filter((a) => a !== item?.leave_data_id)
                                                      return totalcount
                                                    }else{
                                                      totalcount = totalcount + 1
                                                      idRefferrent.push(item.leave_data_id)
                                                      return totalcount
                                                    }
                                                  } return 0 }).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                              }
                                      </td>
                                    }
                                    {i === 8 &&
                                      <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          { monthDataUniqueTime.map((item,itemIdx)=>{
                                            return( Number(item.month) === month[1] 
                                                ? item.leave_type_id === 8 || item.leave_type_id === 7 || item.leave_type_id === 6 
                                                  ? Number(item.leave_days) + result : result + result : null )})
                                                  .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                          }
                                      </td>
                                    }
                                    {i === 11 &&
                                      <Fragment>
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          { monthDataUniqueTime.map((item,itemIdx)=>{
                                                    totalcount = 0
                                                    if (Number(item.month) === month[1] && item.leave_type_id === i ) {
                                                      if(idRefferrent.some((a) => a === item?.leave_data_id)){
                                                        totalcount = totalcount + 0
                                                        idRefferrent.filter((a) => a !== item?.leave_data_id)
                                                        return totalcount
                                                      }else{
                                                        totalcount = totalcount + 1
                                                        idRefferrent.push(item.leave_data_id)
                                                        return totalcount
                                                      }
                                                    } 
                                                    return 0 }).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                                }
                                          </td>
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              { monthDataUniqueTime.map((item,itemIdx)=>{
                                                return( Number(item.month) === month[1] 
                                                    && item.leave_type_id === i 
                                                      ? Number(item.leave_days) + result : result + result )})
                                                      .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                                              }
                                          </td>  
                                      </Fragment>
                                    }
                                </Fragment>)
                                )}
                            )}          
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan="32" className="py-1 text-end">รวมครึ่งปีแรก (ตุลาคม - มีนาคม)</td>
                        {leaveType.map((item,idx)=>{ 
                            return ( 
                              item !== 7 && item !== 6 && 
                              <Fragment key={idx}>
                              {item === 1 &&
                                <Fragment>
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 1) ?
                                      sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                    </td>
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthFirstHalf.find(x => x.leave_type_id === item) ?
                                        sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days : 0 }
                                    </td>
                                </Fragment>
                              }
                              {item === 2 &&
                                <Fragment>
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 2) ?
                                        sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                    </td>
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthFirstHalf.find(x => x.leave_type_id === item) ? 
                                        sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days : 0 }
                                    </td>
                                </Fragment>
                              }

                              {item === 66 &&
                                <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                  {sumarymonthLate?.firstRange?.reduce((max, obj) => obj.count > max.count ? obj : max, sumarymonthLate?.firstRange[0])?.count ?? 0 }
                                </td> 
                              }
                              {item === 77 &&
                                <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                  {sumarymonthLost?.firstRange?.reduce((max, obj) => obj.count > max.count ? obj : max, sumarymonthLost?.firstRange[0])?.count ?? 0 }
                                </td>
                              }
                              {item === 12 &&
                                <Fragment>
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 12) ?
                                    sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                  </td>
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthFirstHalf.find(x => x.leave_type_id === item) ? 
                                      sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days : 0 }
                                  </td>
                                </Fragment>
                              }
                              {item === 4 &&
                                <Fragment>
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 4) ?
                                     sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                  </td>
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthFirstHalf.find(x => x.leave_type_id === item) ? 
                                      sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days : 0 }
                                  </td>
                                </Fragment>
                              }
                              {item === 13 &&
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthFirstHalf.find(x => x.leave_type_id === item) ? 
                                      sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days : 0 }
                                  </td>
                              }
                              {item === 3 &&
                                <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                  {sumarymonthFirstHalf.find(x => x.leave_type_id === item) ? 
                                    sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days : 0 }
                                </td> 
                              }
                              {item === 9 &&
                                <Fragment>
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 9) ?
                                     sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                  </td> 
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthFirstHalf.find(x => x.leave_type_id === item) ? 
                                      sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days : 0 }
                                  </td>
                                </Fragment>
                              }
                              {item === 10 &&
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 10) ?
                                     sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                  </td>
                              }
                              {item === 8 &&
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthFirstHalf.find(x => x.leave_type_id === 8) ?
                                      sumarymonthFirstHalf.find(x => x.leave_type_id === 8)?.leave_days +
                                      sumarymonthFirstHalf.find(x => x.leave_type_id === 7)?.leave_days +
                                      sumarymonthFirstHalf.find(x => x.leave_type_id === 6)?.leave_days : 0 }
                                  </td>
                              }
                              {item === 11 &&
                                <Fragment>
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 11) ?
                                    sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                  </td>
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthFirstHalf.find(x => x.leave_type_id === item) ? 
                                      sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days : 0 }
                                  </td>
                                </Fragment>
                              }
                            </Fragment>
                              )
                        })}
                      </tr>
                      <tr>
                        <td colSpan="32" className="py-1 text-end">รวมครึ่งปีหลัง (เมษายน - กันยายน)</td>
                        {leaveType.map((item,idx)=>{ 
                            return ( 
                              item !== 7 && item !== 6 && 
                              <Fragment key={idx}>
                                {item === 1 &&
                                  <Fragment>
                                      <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                        {sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 1) ?
                                        sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                      </td>
                                      {sumarymonthSecondHalf.find(x => x.leave_type_id === item) && 
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                        </td>
                                      }
                                  </Fragment>
                                }
                                {item === 2 &&
                                  <Fragment>
                                      <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                        {sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 2) ?
                                        sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                      </td>
                                      {sumarymonthSecondHalf.find(x => x.leave_type_id === item) && 
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                        </td>
                                      }  
                                  </Fragment>
                                }
                                {item === 66 &&
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthLate?.secondRange?.reduce((max, obj) => obj.count > max.count ? obj : max, sumarymonthLate?.secondRange[0])?.count ?? 0 }
                                  </td> 
                                }
                                {item === 77 &&
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthLost?.secondRange?.reduce((max, obj) => obj.count > max.count ? obj : max, sumarymonthLost?.secondRange[0])?.count ?? 0 }
                                  </td>
                                }
                                {item === 12 &&
                                  <Fragment>
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 12) ?
                                      sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                    </td>
                                    {sumarymonthSecondHalf.find(x => x.leave_type_id === item) && 
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                        </td>
                                    }
                                  </Fragment>
                                }
                                {item === 4 &&
                                  <Fragment>
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 4) ?
                                       sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                    </td>
                                    {sumarymonthSecondHalf.find(x => x.leave_type_id === item) && 
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                        </td>
                                    }
                                  </Fragment>
                                }
                                {item === 13 &&
                                   sumarymonthSecondHalf.find(x => x.leave_type_id === item) && 
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                    </td>
                                }
                                {item === 3 &&
                                  sumarymonthSecondHalf.find(x => x.leave_type_id === item) && 
                                  <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                    {sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                  </td> 
                                }
                                {item === 9 &&
                                  <Fragment>
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 9) ?
                                       sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                    </td> 
                                    {sumarymonthSecondHalf.find(x => x.leave_type_id === item) && 
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                        </td>
                                    }
                                  </Fragment>
                                }
                                {item === 10 &&
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 10) ?
                                       sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                    </td>
                                }
                                {item === 8 &&
                                  sumarymonthSecondHalf.find(x => x.leave_type_id === 8) &&
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthSecondHalf.find(x => x.leave_type_id === 8)?.leave_days +
                                       sumarymonthSecondHalf.find(x => x.leave_type_id === 7)?.leave_days +
                                       sumarymonthSecondHalf.find(x => x.leave_type_id === 6)?.leave_days}
                                    </td>
                                }
                                {item === 11 &&
                                  <Fragment>
                                    <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                      {sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 11) ?
                                      sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                    </td>
                                    {sumarymonthSecondHalf.find(x => x.leave_type_id === item) && 
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                        </td>
                                    }
                                  </Fragment>
                                }
                              </Fragment>
                                )
                        })}
                      </tr>
                      <tr>
                        <td colSpan="32" className="py-1 text-end">
                          รวม
                        </td>
                          {leaveType.map((item,idx)=>{ 
                            let toltal = sumarymonthSecondHalf.find(x => x.leave_type_id === 8)?.leave_days +
                            sumarymonthSecondHalf.find(x => x.leave_type_id === 7)?.leave_days +
                            sumarymonthSecondHalf.find(x => x.leave_type_id === 6)?.leave_days +
                            sumarymonthFirstHalf.find(x => x.leave_type_id === 8)?.leave_days +
                            sumarymonthFirstHalf.find(x => x.leave_type_id === 7)?.leave_days +
                            sumarymonthFirstHalf.find(x => x.leave_type_id === 6)?.leave_days;
                              return ( 
                                item !== 7 && item !== 6 && 
                                  <Fragment key={idx}>
                                      {item === 1 &&
                                        <Fragment>
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                            {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 1) ?
                                            sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 +
                                            sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 1) ?
                                            sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                          </td>
                                          {sumarymonthFirstHalf.find(x => x.leave_type_id === item) || 
                                           sumarymonthSecondHalf.find(x => x.leave_type_id === item) ? 
                                            <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                                {sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days +
                                                sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                            </td> 
                                            : ''
                                          }
                                        </Fragment>
                                      }
                                      {item === 2 &&
                                        <Fragment>
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 2) ?
                                          sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 +
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 2) ?
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                        </td>
                                        {sumarymonthFirstHalf.find(x => x.leave_type_id === item) || 
                                         sumarymonthSecondHalf.find(x => x.leave_type_id === item) ? 
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              {sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days +
                                              sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                          </td> 
                                          : ''
                                        }
                                      </Fragment>
                                      }
                                      {item === 66 &&
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {
                                            sumarymonthLate ? 
                                              (sumarymonthLate?.firstRange
                                                ?.reduce((max, obj) => obj.count > max.count ? obj : max, sumarymonthLate?.firstRange[0])?.count ?? 0) + 
                                              (sumarymonthLate?.secondRange
                                                ?.reduce((max, obj) => obj.count > max.count ? obj : max, sumarymonthLate?.secondRange[0])?.count ?? 0)
                                            : 0
                                          }
                                        </td> 
                                      }
                                      {item === 77 &&
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                           {
                                            sumarymonthLost ? 
                                              (sumarymonthLost?.firstRange
                                                ?.reduce((max, obj) => obj.count > max.count ? obj : max, sumarymonthLost?.firstRange[0])?.count ?? 0) + 
                                              (sumarymonthLost?.secondRange
                                                ?.reduce((max, obj) => obj.count > max.count ? obj : max, sumarymonthLost?.secondRange[0])?.count ?? 0)
                                            : 0
                                          }
                                        </td>
                                      }
                                      {item === 12 &&
                                        <Fragment>
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 12) ?
                                          sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 +
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 12) ?
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                        </td>
                                        {sumarymonthFirstHalf.find(x => x.leave_type_id === item) || 
                                         sumarymonthSecondHalf.find(x => x.leave_type_id === item) ? 
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              {sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days +
                                              sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                          </td> 
                                          : ''
                                        } 
                                        </Fragment>
                                      }
                                      {item === 4 &&
                                        <Fragment>
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 4) ?
                                          sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 +
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 4) ?
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                        </td>
                                        {sumarymonthFirstHalf.find(x => x.leave_type_id === item) || 
                                         sumarymonthSecondHalf.find(x => x.leave_type_id === item) ? 
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              {sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days +
                                              sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                          </td> 
                                          : ''
                                        } 
                                        </Fragment>
                                      }
                                      {item === 13 &&
                                        <Fragment>
                                            {sumarymonthFirstHalf.find(x => x.leave_type_id === item) || 
                                          sumarymonthSecondHalf.find(x => x.leave_type_id === item) ? 
                                            <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                                {sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days +
                                                sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                            </td> 
                                            : ''
                                          } 
                                        </Fragment>
                                      }
                                      {item === 3 &&
                                        <Fragment>
                                          {sumarymonthFirstHalf.find(x => x.leave_type_id === item) || 
                                          sumarymonthSecondHalf.find(x => x.leave_type_id === item) ? 
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              {sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days +
                                              sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                          </td> 
                                          : ''
                                          } 
                                       </Fragment>
                                      }
                                      {item === 9 &&
                                        <Fragment>
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 9) ?
                                          sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 +
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 9) ?
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                       </td>
                                        {sumarymonthFirstHalf.find(x => x.leave_type_id === item) || 
                                        sumarymonthSecondHalf.find(x => x.leave_type_id === item) ? 
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              {sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days +
                                              sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                          </td> 
                                          : ''
                                        } 
                                      </Fragment>
                                      }
                                      {item === 10 &&
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                        {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 10) ?
                                        sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 +
                                        sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 10) ?
                                        sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                      </td>
                                      }
                                      {item === 8 &&
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                        {isNaN(toltal) ? "0" : toltal }
                                      </td>
                                      }
                                      {item === 11 &&
                                        <Fragment>
                                        <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                          {sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === 11) ?
                                          sumarymonthCountFirstHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 +
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === 11) ?
                                          sumarymonthCountSecondHalf.find(x => Number(x.leave_type_id) === item).leave_data_id_count : 0 }
                                        </td>
                                        {sumarymonthFirstHalf.find(x => x.leave_type_id === item) || 
                                         sumarymonthSecondHalf.find(x => x.leave_type_id === item) ? 
                                          <td className="text-center p-0" style={{ verticalAlign: "middle" }}>
                                              {sumarymonthFirstHalf.find(x => x.leave_type_id === item)?.leave_days +
                                              sumarymonthSecondHalf.find(x => x.leave_type_id === item)?.leave_days}
                                          </td> 
                                          : ''
                                        } 
                                        </Fragment>
                                      }
                                  </Fragment>
                                )
                          })}
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <Row className="mx-1 my-2">
                <Col xs={6} lg={6} xxl={6}>
                  <Row>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#6699AA" }}> ป </h4>
                        <h5 className="m-0">ป่วย</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#FFFF88" }}> ก </h4>
                        <h5 className="m-0">ลากิจ</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#B9E3AE", paddingRight: "19px" }}> ศ </h4>
                        <h5 className="m-0">ศึกษา/อบรม/ดูงาน</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#FF9797" }}> ส </h4>
                        <h5 className="m-0">สาย</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 className="modal-card-h4" style={{ background: "#000", color: "white" }}> พ </h4>
                        <h5 className="m-0">พักผ่อน</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#CBAB8D" }} className="modal-card-h4"> บ </h4>
                        <h5 className="m-0">เลี้ยงดูบุตร</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#88BBAA" }} className="modal-card-h4"> ค </h4>
                        <h5 className="m-0">คลอด</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#88BBDD", paddingRight: "17.5px" }} className="modal-card-h4"> ข </h4>
                        <h5 className="m-0">ขาด</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#BACAB3", paddingRight: "19px" }} className="modal-card-h4"> ม </h4>
                        <h5 className="m-0">ติดตามคู่สมรส</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#FFBE7D", paddingRight: "19px" }} className="modal-card-h4"> ฮ </h4>
                        <h5 className="m-0">เตรียมพล/พิธีฮัจญ์/อุปสมบท</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#C96868", paddingRight: "19px" }} className="modal-card-h4"> น </h4>
                        <h5 className="m-0">การไปปฏิบัติราชการนอกสำนักงาน ก.พ.ร.</h5>
                      </div>
                    </Col>
                    <Col xs={3} lg={3} xl={3} style={{ display: "flex", alignItems: "center" }}>
                      <div className="modal-card-leave">
                        <h4 style={{ background: "#7776B3", paddingRight: "19px" }} className="modal-card-h4"> ล </h4>
                        <h5 className="m-0">การลงเวลาปฏิบัติราชการ</h5>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </FadeIn>
        )}
      </ModalBody>

      <Row className="mx-1 my-2">
        <Col
          lg={{
            offset: 7,
            order: 4,
            size: 5,
          }}
        >
          <div className="text-end me-2">
            <Button
              className="mt-2 "
              color="success"
              onClick={downloadPDF}
              disabled={buttonLoading}
            >
              {buttonLoading === true ? (
                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              ) : (
                <i className="fa-solid fa-print pe-2"></i>
              )}
              พิมพ์
            </Button>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalCardLeave;
